import cn from "classnames";
import { FCAdditionalProps } from "@datassential/platform-ui-lib/lib/core/models";
import React, { ReactNode } from "react";

interface ITabItem<T extends ReactNode = string> {
    title: T;
    isActive?: boolean;
    onClick?: () => void;
}

type Modifier = 'test';

type Props<T extends ReactNode = string> = FCAdditionalProps & {
    data: ITabItem<T>[];
    modifiers?: Modifier[];
}

const SlashSelect = <T extends ReactNode = string>({
    data,
    modifiers = [],
    testId,
    className,
    ...rest
}: Props<T>) => {
    return (
        <div
            className={cn(
                className,
                "SlashSelect",
                ...modifiers.map(i => `is-${i}`),
            )}
            data-testid={testId}
            {...rest}
        >
            {data.map(({ title, isActive, onClick }, index) => (
                <React.Fragment key={title as string}>
                    <div
                        className={
                            cn(
                                "SlashSelect__item",
                                isActive && "is-active",
                            )
                        }
                        onClick={!isActive ? onClick : undefined}
                        data-testid={`buttonSlashSelectItem${index}`}
                        >
                        {title as ReactNode}
                    </div>
                    {index !== data.length - 1 && <div className="SlashSelect__divider">/</div>}
                </React.Fragment>
            ))}
        </div>
    );
}

export default SlashSelect;